(function (window, document, jQuery, undefined) {
    var $ = jQuery.noConflict();

    $(document).ready(function () {
        function topFunction() {
            document.body.scrollTop = 0; 
            document.documentElement.scrollTop = 0; 
        }

        function scrollFunction() {
            if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
                scrollToTopBtn.style.display = "block";
            } else {
                scrollToTopBtn.style.display = "none";
            }
        }  

        var scrollToTopBtn = document.getElementById("scrollToTopBtn");

        if (scrollToTopBtn != null) {
            scrollToTopBtn.addEventListener("click", topFunction);

            window.onscroll = function () { scrollFunction() };
        }      
    });
})(window, document, jQuery);